






import { VBtn } from 'vuetify/lib'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'base-button',
  components: {
    VBtn
  },
  props: {
    tile: {
      type: Boolean,
      default: true
    }
  }
})
